<script setup>
import { ref, computed, onBeforeMount, onMounted } from "vue";
import useValidation from "@/utils/helpers/validations";
import { useCompanyStore } from "@/stores/company";
import { useUiStore } from "@/stores/ui";
import { useUrlsStore } from "@/stores/urls";

const uiStore = useUiStore();
const urlsStore = useUrlsStore();
const emit = defineEmits(["refresh"]);
const company_id = useCompanyStore().companyId;
const { checkUrlValidation } = useValidation();
const getModalAction = computed(() => uiStore.modalAction);

const name = ref(null);
const url = ref(null);
const description = ref(null);
const parent_id = ref(null);
const depth = ref(null);
const isValidUrl = ref(true);
const isSubmitted = ref(false);

const validUrl = () => {
  isValidUrl.value = true;
  if (url.value && url.value.length > 0) {
    isValidUrl.value = checkUrlValidation(url.value);
    return isValidUrl.value;
  }
};

const onSubmit = () => {
  isSubmitted.value = true;
  const data = {
    company_id,
    data: {
      name: name.value,
      description: description.value,
      url: url.value,
      depth: depth.value,
      parent_id: parent_id.value,
    },
  };

  urlsStore
    .addUrl(data)
    .then(() => {
      isSubmitted.value = false;
      resetStoreData();
      emit("refresh");
    })
    .catch(() => {
      isSubmitted.value = false;
    });
};

const resetStoreData = () => {
  uiStore.resetModalStore();
};

onMounted(() => {
  if (uiStore.modalAction == "add_url") {
    // expected
  }
});

onBeforeMount(() => {
  if (uiStore.modalData && uiStore.modalAction == "add_url") {
    parent_id.value = uiStore.modalData.headerAction ? null : uiStore.modalData.id;
  }
});
</script>

<template>
  <DModal v-if="getModalAction === 'add_url'" :visible="uiStore.modalState" @update:visible="val => { if (!val) resetStoreData() }" :main_classes="[]" :dialog_classes="[]">
    <template #title> Add New Website </template>

    <template #body>
      <!-- <div class="mb-3">
        <span class="map-hint">Please pick up the area location on the map</span>
      </div> -->

      <!-- <div class="map-card p-0 mb-3">
        <div id="mapArea" style="height:34vh;"></div>
      </div> -->

      <div class="mb-3">
        <DInput
          label="URL Name"
          :value="name"
          @input="name = $event.target.value"
          type="text"
          width="100%"
        />
      </div>

      <div class="mb-3">
        <DInput
          label="URL"
          :value="url"
          @input="url = $event.target.value; validUrl()"
          type="text"
          width="100%"
        />
        <div v-if="!isValidUrl" class="invalid-feedback">Invalid URL.</div>
      </div>
      <FloatLabel class="w-full mb-3">
        <PTextarea
          v-model="description"
          id="description"
          class="d-textarea resize-none h-105 w-full"
          autoResize
        />
        <label for="description">Description (Optional)</label>
      </FloatLabel>
    </template>
    <template #footer>
      <div class="w-full">
        <div class="seperator text-center"></div>
        <div class="flex mt-20 justify-center">
          <button
            :disabled="!name || !url || isSubmitted"
            @click="onSubmit"
            type="button"
            class="btn btn-primary add-button mr-30"
          >
            Add
            <span
              v-if="isSubmitted"
              class="spinner-sm"
              role="status"
              aria-hidden="true"
            ></span>
          </button>
          <button
            @click="resetStoreData"
            type="button"
            class="btn btn-secondary cancel-button"

          >
            Cancel
          </button>
        </div>
      </div>
    </template>
  </DModal>
</template>
